var category = new function() {
    var me = this;
    this.containerAmong;
    this.durningRequest = false;

    this.showNext = function(el) {
      me.sendRequest(el);
    };

    this.sendRequest = function(el){
          categoryBox = $(el).closest("[data-category-box]");
          container = categoryBox.find("[data-category-container]");

           var data = {
                category_id: categoryBox.data("category-id"),
                page_nr: parseInt(categoryBox.data("category-page")) + 1,
                _token: Laravel.csrfToken,
                language: $('html').attr('lang')
            };

            var requestParams = document.location.href.split('/').pop().split(',');

            if(requestParams.length > 1 && parseInt(requestParams[1])>=1 && parseInt(requestParams[1])<=12)
              data.month = requestParams[1];
            if(requestParams.length > 2)
              data.year = requestParams[2];
            else if(requestParams.length==2)
              data.year = requestParams[1];

            if(!me.durningRequest)
              me.getPosts(data,categoryBox);


    };

    this.getPosts = function(data,categoryBox){
      me.durningRequest = true;
      $.ajax({
          url: "/module/postfromcategory",
          method: "POST",
          data: data,
          dataType: "json",
          success: function (data) {
              if (data.posts.length == 0) {
                  categoryBox.find('button').remove();
              } else {
                  var template = $("#entry-template").html();
                  var stone = Handlebars.compile(template)(data);
                  var $items = $.parseHTML(stone);

                  container.append($items);

                  categoryBox.data('category-page', data.page);

                  me.durningRequest = false;

                  //console.log(data.posts.length);
                  //console.log(parseInt(categoryBox.data("category-perpage")));
                  if(data.posts.length < parseInt(categoryBox.data('category-perpage'))){
                    categoryBox.find('button').remove();
                  }
              }
          }
      });
    };

    this.bindEvents = function() {
        $("[data-category-loadpage]").bind("click", function() {
            me.showNext($(this));
        });
    };

};

$(document).ready(function () {
    category.bindEvents();

    $('.loader').on('inview', function (event, isInView) {
        if (isInView) {
            var data = {
                category_id: $("[data-category-id]").data("category-id"),
                page_nr: parseInt($("[data-category-page]").data("category-page")) + 1,
                _token: Laravel.csrfToken
            };

            $.ajax({
                url: "/module/postfromcategory",
                method: "POST",
                data: data,
                dataType: "json",
                success: function (data) {
                    if (data.posts.length == 0) {
                        $(".loader").remove();
                    } else {
                        var template = $("#entry-template").html();
                        var stone = Handlebars.compile(template)(data);
                        var $items = $.parseHTML(stone);
                        container.append($items).isotope('appended', $items);

                        $("[data-category-page]").data('category-page', data.page);
                        $(".loader").data("offset", data.offset);
                    }
                }
            });
        }
    });
});
